<template>
  <v-card v-if="accountData != null" flat class="pa-3 mt-2">
    <v-card-text class="d-flex justify-center pb-0">
      <!-- upload photo -->
      <div>
        <avatar-image-component
          :edit="adminProfileStore.id == accountData.id"
          :avatarUrl="accountData.avatar"
          :user="accountData"
        ></avatar-image-component>
      </div>
    </v-card-text>

    <v-card-text>
      <v-form
        ref="form"
        v-model="valid"
        class="multi-col-validation mt-6"
        lazy-validation
      >
        <v-row>
          <v-col md="6" cols="12">
            <v-text-field
              v-model="accountData.name"
              :label="$t('forms.name')"
              dense
              outlined
              required
              :rules="nameRules"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              v-model="accountData.email"
              :label="$t('forms.email')"
              :disabled="accountData.id == 1"
              dense
              outlined
              required
              :rules="emailRules"
              ref="emailField"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-select
              disabled
              v-model="accountData.role_id"
              dense
              outlined
              :label="$t('forms.role')"
              :items="roles"
              item-text="role"
              item-value="value"
            ></v-select>
          </v-col>

          <v-col cols="12" md="6" v-if="userType === 'student'">
            <v-autocomplete
              v-model="accountData.parent_ids"
              :items="guardians"
              item-text="name"
              item-value="id"
              dense
              outlined
              multiple
              :label="$t('forms.parent')"
              :rules="parentRules"
            ></v-autocomplete>
          </v-col>

          <v-col
            cols="12"
            md="6"
            v-if="adminProfileStore.id !== accountData.id"
          >
            <v-select
              v-model="accountData.status_id"
              :disabled="accountData.id == 1"
              dense
              outlined
              :label="$t('forms.status')"
              :items="statuses"
              item-text="status"
              item-value="value"
            ></v-select>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              v-model="accountData.tel_number"
              outlined
              dense
              :label="$t('forms.phone')"
              :rules="phoneRules"
              ref="phoneField"
            ></v-text-field>
          </v-col>

          <!--          <v-col cols="12" md="6" v-if="userType == 'student'">-->
          <!--            <v-text-field-->
          <!--              v-model="accountData.student_identification"-->
          <!--              outlined-->
          <!--              dense-->
          <!--              label="Student ID"-->
          <!--            ></v-text-field>-->
          <!--          </v-col>-->

          <!--          <v-col-->
          <!--            v-else-if="-->
          <!--              userType == 'school' ||-->
          <!--              (userType == 'guardian' && accountData.role_id == 4)-->
          <!--            "-->
          <!--          >-->
          <!--            <v-text-field-->
          <!--              v-model="accountData.balance"-->
          <!--              :disabled="userType == 'guardian' && accountData.role_id == 4"-->
          <!--              outlined-->
          <!--              dense-->
          <!--              label="Balance"-->
          <!--            ></v-text-field>-->
          <!--          </v-col>-->

          <v-col cols="12" md="6" v-if="userType === 'student'">
            <v-autocomplete
              v-model="accountData.student_school_id"
              :items="schools"
              item-text="name"
              item-value="id"
              dense
              outlined
              :label="$t('forms.school')"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" md="6" v-if="userType === 'student'">
            <v-autocomplete
              v-model="accountData.group_id"
              :items="groups"
              item-text="name"
              item-value="id"
              dense
              outlined
              :label="$t('forms.class')"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" md="6" v-if="userType === 'student'">
            <t-time-field
              outlined
              :label="$t('forms.time_from')"
              v-model="accountData.time_from"
              append-icon="mdi-calendar"
              readonly
            ></t-time-field>
          </v-col>

          <v-col cols="12" md="6" v-if="userType === 'student'">
            <t-time-field
              outlined
              :label="$t('forms.time_to')"
              v-model="accountData.time_to"
              append-icon="mdi-calendar"
              readonly
            ></t-time-field>
          </v-col>

          <v-col cols="12" md="6" v-if="userType === 'student'">
            <v-textarea
              outlined
              name="input-7-4"
              :label="$t('forms.address')"
              v-model="accountData.address"
              rows="2"
            ></v-textarea>
          </v-col>

          <v-col cols="12">
            <v-btn color="primary" class="me-3 mt-4" @click="saveUser">
              {{ $t('actions.save_changes') }}
            </v-btn>
            <v-btn color="secondary" outlined class="mt-4" @click="cancel">
              {{ $t('actions.cancel') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import AvatarImageComponent from '../../../components/AvatarImageComponent.vue';
import { mdiAlertOutline, mdiCloudUploadOutline } from '@mdi/js';
import { adminProfileStore } from '@/utils/helpers';
import TTimeField from '@/layouts/components/t-time-field/t-time-field.vue';

export default {
  components: {
    TTimeField,
    AvatarImageComponent,
  },
  setup() {
    return { adminProfileStore };
  },
  props: {
    accountData: {
      type: Object,
      default: () => {},
    },
    userType: {
      type: String,
      default: () => {},
    },
  },
  data() {
    return {
      valid: true,
      nameRules: [(v) => !!v || this.$t('forms.name_is_required')],
      // emailRules: [
      //   (v) => !!v || 'E-mail is required',
      //   (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      // ],
      emailRules: [],
      parentRules: [(v) => !!v || this.$t('forms.parent_is_required')],
      // phoneRules: [(v) => /^(|\d)+$/.test(v) || 'Phone must be valid'],
      phoneRules: [],
      statuses: [
        { status: this.$t('table.active'), value: 1 },
        //{ status: this.$t('table.pending'), value: 2 },
        { status: this.$t('table.suspended'), value: 3 },
      ],
      roles: [
        { role: this.$t('roles.admin'), value: 1 },
        { role: this.$t('roles.organisation'), value: 2 },
        { role: this.$t('roles.driver'), value: 3 },
        { role: this.$t('roles.parent'), value: 4 },
        { role: this.$t('roles.guardian'), value: 5 },
        { role: this.$t('roles.student'), value: 6 },
      ],
      icons: {
        mdiAlertOutline,
        mdiCloudUploadOutline,
      },
      guardians: [],
      schools: [],
      groups: [],
    };
  },
  mounted() {
    if (this.userType === 'student') {
      this.getAllGuardiansList();
      this.getAllSchoolsList();
    }
    this.updateContactRules();
  },
  methods: {
    validate() {
      return this.$refs.form.validate();
    },
    updateContactRules() {
      const hasEmail = !!this.accountData?.email;
      const hasPhone = !!this.accountData?.tel_number;

      this.emailRules = [
        (v) => {
          if (!v && !hasPhone)
            return this.$t('forms.either_email_or_phone_is_required');
          return true;
        },
        (v) =>
          !v || /.+@.+\..+/.test(v) || this.$t('forms.e_mail_must_be_valid'),
      ];

      this.phoneRules = [
        (v) => {
          if (!v && !hasEmail)
            return this.$t('forms.either_email_or_phone_is_required');
          return true;
        },
        (v) => !v || /^\d+$/.test(v) || this.$t('forms.phone_must_be_numeric'),
      ];

      this.$nextTick(() => {
        this.$refs.emailField?.validate?.();
        this.$refs.phoneField?.validate?.();
      });
    },
    getAllGuardiansList() {
      axios.get(`/users/all-guardians/list`).then((response) => {
        this.guardians = response.data;
      });
    },
    getAllSchoolsList() {
      axios.get(`/schools/list`).then((response) => {
        this.schools = response.data;
      });
    },
    getAllGroupsList(school_id) {
      axios.get(`/classes/list?school_id=${school_id}`).then((response) => {
        this.groups = response.data;
      });
    },
    saveUser() {
      if (!this.validate()) return;
      this.$emit('save-user-info');
    },
    cancel() {
      this.$router.go(-1);
    },
  },
  watch: {
    'accountData.email': 'updateContactRules',
    'accountData.tel_number': 'updateContactRules',
    userType: {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue && newValue === 'student') {
          this.getAllGuardiansList();
        }
      },
    },
    'accountData.student_school_id': {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue && newValue !== oldValue) {
          this.getAllGroupsList(newValue);
        }
      },
    },
  },
};
</script>
